module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabCage table6E"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [(_vm.pressType == 1) ? _c('span', [_vm._v("表 1-6：重点音像制品情况登记表")]) : _c('span', [_vm._v("表 1-6：重点电子出版物情况登记表")])]), _vm._v(" "), _c('div', {
    staticClass: "editArea"
  }, [_c('el-form', {
    ref: "paramCk",
    attrs: {
      "model": _vm.params,
      "rules": _vm.rules
    }
  }, [_c('table', [_c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("项目名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpBig"
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.proName),
      callback: function($$v) {
        _vm.$set(_vm.params, "proName", $$v)
      },
      expression: "params.proName"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("重点项目名称：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.importantProName),
      callback: function($$v) {
        _vm.$set(_vm.params, "importantProName", $$v)
      },
      expression: "params.importantProName"
    }
  }, _vm._l((_vm.dicDats['C021']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  })), _vm._v(" "), (_vm.dicMap['C021'][_vm.params.importantProName] == '其他') ? _c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.importantProNameOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "importantProNameOther", $$v)
      },
      expression: "params.importantProNameOther"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("级别：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-select', {
    attrs: {
      "disabled": "",
      "size": "small",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.params.hjLevel),
      callback: function($$v) {
        _vm.$set(_vm.params, "hjLevel", $$v)
      },
      expression: "params.hjLevel"
    }
  }, _vm._l((_vm.dicDats['C024']), function(item) {
    return _c('el-option', {
      key: item.code,
      attrs: {
        "label": item.name,
        "value": item.code
      }
    })
  })), _vm._v(" "), (_vm.dicMap['C024'][_vm.params.hjLevel] == '其他') ? _c('el-input', {
    attrs: {
      "disabled": "",
      "size": "small"
    },
    model: {
      value: (_vm.params.hjLevelOther),
      callback: function($$v) {
        _vm.$set(_vm.params, "hjLevelOther", $$v)
      },
      expression: "params.hjLevelOther"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("拟定完成时间：")]), _vm._v(" "), _c('td', {
    staticClass: "edInp"
  }, [_c('el-date-picker', {
    attrs: {
      "disabled": "",
      "align": "right",
      "type": "date",
      "size": "small",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.params.ydDate),
      callback: function($$v) {
        _vm.$set(_vm.params, "ydDate", $$v)
      },
      expression: "params.ydDate"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "edName"
  }, [_vm._v("备注：")]), _vm._v(" "), _c('td', {
    staticClass: "edInpTextArea"
  }, [_c('el-input', {
    attrs: {
      "rows": 3,
      "disabled": "",
      "type": "textarea",
      "size": "small"
    },
    model: {
      value: (_vm.params.remark),
      callback: function($$v) {
        _vm.$set(_vm.params, "remark", $$v)
      },
      expression: "params.remark"
    }
  })], 1)])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "subArea"
  }, [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("返回")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66d80cea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/SPEC/glanceDcp/table6.vue
// module id = 1762
// module chunks = 1